




import { CoreComponent } from '@empathybroker/ebx-gluon';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    EmpathyX: CoreComponent
  }
})
export default class App extends Vue {}
